var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-cell-action-base',_vm._b({directives:[{name:"cell-action-edit",rawName:"v-cell-action-edit",value:({
        quick: _vm.quick,
        id: _vm.row.id,
        updated: _vm.doTableReload,
    }),expression:"{\n        quick,\n        id: row.id,\n        updated: doTableReload,\n    }"}],attrs:{"icon":"fa-pen","label":_vm.defaultLabel}},'iv-cell-action-base',{ ..._vm.$attrs, ..._vm.$props },false))
}
var staticRenderFns = []

export { render, staticRenderFns }